import OnboardingWizard from './OnboardingWizard';
export default OnboardingWizard;
